/**
 * The interface config keys to whitelist, the keys that can be overridden.
 *
 * @private
 * @type Array
 */
export default [
    'disablePrejoinFooter',
    'disablePrejoinHeader',
    'SHOW_MEET_HOUR_WATERMARK',
    'genericIFrameTemplateUrl',
    'HIDE_DEEP_LINKING_LOGO',
    'MOBILE_APP_PROMO',
    'ENABLE_MOBILE_BROWSER',
    'DEFAULT_BACKGROUND',
    'showJoinAsModerator',
    'applyMeetingSettings',
    'ENABLE_DESKTOP_DEEPLINK',
    'DISABLE_VOICE_COMMAND',
    'CHANGE_MODERATOR_NAME',
    'APP_SCHEME',
    'ANDROID_APP_PACKAGE',
    'displayLogoInRecorder',
    'hideParticipantTilesOnRecording',
    'DESKTOP_APP_SCHEME',
    'MAC_DOWNLOAD_LINK',
    'LINUX_DOWNLOAD_LINK',
    'WINDOWS_DOWNLOAD_LINK'
];
